import { appEfrConfig, efrBotPaths } from './app.efr.config';
import { appEfrFastConfig, efrFastBotPaths } from './app.efrFast.config';
import { appRekiConfig, rekiBotPaths } from './app.reki.config';

export const appConfig = {
	efr: appEfrConfig,
	efrFast: appEfrFastConfig,
	reki: appRekiConfig,
};
export const botPaths = {
	efr: efrBotPaths,
	efrFast: efrFastBotPaths,
	reki: rekiBotPaths,
};
